import React, { FC } from 'react';
import { Box, Tabs, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { useTemplateContext } from '@components/Contexts/TemplateContext';
import useMobileTemplatePageTabs, {
  TemplatePageTabID,
} from '../useMobileTemplatePageTabs';
import { useTemplateBi } from '@components/Hooks/useTemplateBi';
import PurchaseTemplateButton from '@components/Template/PurchaseTemplateButton';
import { useHeaderContext } from '@components/Contexts/HeaderContext';
import s from './StickyTabsNavBar.module.scss';

type Props = ReturnType<typeof useMobileTemplatePageTabs> & {
  setPurchaseError: (isError: boolean) => void;
};

const StickyTabsNavBar: FC<Props> = ({
  activeTabId,
  setActiveTabId,
  tabItems,
  setPurchaseError,
}) => {
  const { template, showStickyCTAs } = useTemplateContext();
  const { userDetails } = useHeaderContext();
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { logBiClick, TAB_ID_TO_BI_NAME } = useTemplateBi({ is_mobile: true });
  return (
    <div className={s.stickyTabsBar} data-hook="mobile-sticky-tabs-bar">
      <Box
        className={`${s.stickyTabsBarSummary} ${
          showStickyCTAs ? '' : s.hidden
        }`}
      >
        <Box direction="vertical">
          <Text size="small" weight="bold">
            {template.title}
          </Text>
          <Text size="tiny" weight="thin">
            {t('marketplace.template-page.mobile.sticky-nav.created-by', {
              name: template.partnerProfileDetails.businessName,
            })}
          </Text>
        </Box>
        <PurchaseTemplateButton
          showShortFreeCta={true}
          hasShortCTA={true}
          buttonSize="small"
          price={template.price}
          templateId={template.id!}
          logBiClick={() =>
            logBiClick({ clickType: 'purchase mobile minimized' })
          }
          userDetails={userDetails}
          language={language}
          setPurchaseError={setPurchaseError}
          consentModalProps={{
            hasConsentModal: template.hasVeloOrBlocks,
            onModalBiClick: (clickType: string) => logBiClick({ clickType }),
            isMobileView: true,
          }}
        />
      </Box>
      <Tabs
        minWidth="0px"
        size="small"
        type="uniformFull"
        hasDivider
        items={tabItems}
        activeId={activeTabId}
        className={s.tabs}
        onClick={(value) => {
          setActiveTabId(value.id as TemplatePageTabID);
          logBiClick({
            clickType: TAB_ID_TO_BI_NAME[value.id as TemplatePageTabID],
          });
        }}
      />
    </div>
  );
};

export default StickyTabsNavBar;
